'use client';

import type { Data } from 'plotly.js';
import { POD_PALETTE } from '@/app/rate-limit-metrics/types';
import { PlotlyChart } from '@/app/rate-limit-metrics/components/PlotlyChart';
import type { ChartMetric, WorkloadSeries } from '../types';

function colorForName(name: string, index: number): string {
  let hash = 0;
  for (const character of name) hash = ((hash << 5) - hash + character.charCodeAt(0)) | 0;
  return POD_PALETTE[Math.abs(hash + index) % POD_PALETTE.length];
}

export function UserTimeChart({
  series,
  metric,
  hiddenSeries,
  onToggleSeries,
  onIsolateSeries,
  onAddClientGroup,
  loading,
}: {
  series: WorkloadSeries[];
  metric: ChartMetric;
  hiddenSeries: Set<string>;
  onToggleSeries: (name: string) => void;
  onIsolateSeries: (name: string) => void;
  onAddClientGroup?: (client: string) => void;
  loading?: boolean;
}) {
  const unit = metric === 'processingLoad'
    ? 'concurrency'
    : metric === 'requestRate' ? 'requests/s' : 'ms';
  const legendValueLabel = metric === 'processingLoad'
    ? 'Concurrency'
    : metric === 'requestRate' ? 'RPS' : 'Avg duration';
  const traces: Data[] = series.map((item, index) => ({
    type: 'scatter',
    mode: 'lines',
    name: item.label,
    x: item.timestamps.map((timestamp) => new Date(timestamp)),
    y: item[metric],
    line: { width: 1.5, color: colorForName(item.key, index), shape: 'linear' },
    meta: { legendParts: item.legendParts },
    hovertemplate: `<b>${item.label}</b><br>%{x}<br>%{y:.1f} ${unit}<extra></extra>`,
  } as Data));

  return (
    <PlotlyChart
      traces={traces}
      yTitle={unit}
      legendValueLabel={legendValueLabel}
      height={250}
      perPod={false}
      showLegend
      hiddenSeries={hiddenSeries}
      onToggleSeries={onToggleSeries}
      onIsolateSeries={onIsolateSeries}
      onAddClientGroup={onAddClientGroup}
      loading={loading}
    />
  );
}
